import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { MyNavigation } from './MyNavigation';
interface MyAsideNavigationLayoutProps {
  children: React.ReactNode;
}
export const MyAsideNavigationLayout = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-1 gap-60 px-40 pt-36 content-container", "mobile-tablet:max-w-full mobile-tablet:px-0 mobile-tablet:pt-0");
    t2 = <aside className={cn("shrink-0 basis-160 pb-36", "mobile-tablet:hidden")}><MyNavigation /></aside>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <div className={t1}>{t2}<div className="flex w-full flex-1 flex-col">{children}</div></div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};